// components/SuccessModal.jsx
import React from "react";
import { FaTimes } from "react-icons/fa";
import "../tutorRegistration/TutorRegistration.css"; // Assuming styles are in parent CSS

const SuccessModal = ({
  show,
  onClose,
  onProceed,
  title = "Welcome to Tutorslinks community 🤗",
  subtitle = "Breathe easy and unwind! We've got your details, and our team is on it. You'll be up and running before you know you it. Thanks for hanging in there!",
  imageSrc = "/images/success.jpg",
  imageAlt = "Welcome",
  proceedButtonText = "Proceed to Home"
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="completion-modal">
        <button className="modal-close" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="modal-content">
          <img src={imageSrc} alt={imageAlt} className="modal-image" />
          <h2 className="modal-title">{title}</h2>
          <p className="modal-subtitle">{subtitle}</p>
          <button onClick={onProceed} className="proceed-btn">
            {proceedButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;